module.exports = __webpack_public_path__ + "9422562b29eef50d413ae2f0b7c7ebd3.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/areas/areas-startup-circle.png
// module id = 127
// module chunks = 0